<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     消息中心-公告详情
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="fnc-notice-detail">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>

    <el-card v-loading="loading" shadow="never" class="mb-md" :body-style="{ margin: '100px auto', width: '720px' }">
      <div class="article-container">
        <div class="title">{{ notice.title }}</div>
        <div ref="noticeContent" class="content" v-html="notice.content" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { readNoticeApi } from '@/api/fnc/fncNoticeApi'
export default {
  name: 'FncNoticeDetail',
  data() {
    return {
      loading: false,
      id: null,
      notice: {}
    }
  },
  created() {
    this.id = this.$route.query.id
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      readNoticeApi(this.id).then(res => {
        this.loading = false
        if (!res.errno) {
          this.notice = Object.assign({}, res.data)
          // 异步图片预览
          this.$nextTick(() => {
            const images = this.$refs['noticeContent'].getElementsByTagName('img')
            if (images.length > 0) {
              for (const image of images) {
                image.setAttribute('role', 'button')
                image.setAttribute('preview', 'image-666666666')
              }
            }
            this.$previewRefresh()
          })
        } else {
          this.$alert('访问的公告不存在！', {
            type: 'error',
            callback: () => this.$router.go(-1)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.fnc-notice-detail {
  width: 1200px;
  margin: 0 auto;
  .article-container {
    .title {
      font-size: 18px;
      text-align: center;
    }
    .content {
      margin-top: 60px;
      font-size: 14px;
    }
  }
}
</style>
